module.exports = __webpack_public_path__ + "static/media/arrow-down.14868ee2.svg";